<script lang="ts">
  import SectionEtablissementAffiliations from '@/generated/sections/SectionEtablissementAffiliations.vue';
  import { Fiches } from '@/generated/classes/AppSchema';
  import { Sections } from '@/generated/classes/AppSchema';
  import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { AppSections, RessourceAppSection } from '@/ressources/globalRessources';
  import { defineComponent } from "vue";
  import {storeSession} from "@/generated/stores";

  export default defineComponent({
    components: {},
    extends: SectionEtablissementAffiliations,
    computed: {
      ressource () {
        if (this.fiche == Fiches.ETABLISSEMENT) {
          return RessourceGenSection(GenSection.ETABLISSEMENT_AFFILIATIONS);
        } else {
          return RessourceAppSection(AppSections.ETABLISSEMENT_AFFILIATION);
        }
      },
      fields (): string[] {
        return ['POLE_EMPLOI_AFFILIATION', 'POLE_EMPLOI_ADHESION', 'POLE_EMPLOI_IDENTIFIANT', 'STATUT_LICENCE_SPECTACLE', 'LICENCE_SPECTACLE'];
      }
    },
    methods: {
      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
          const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("POLE_EMPLOI_AFFILIATION", true);
          this.displayMap.set("POLE_EMPLOI_ADHESION", true);
          this.displayMap.set("POLE_EMPLOI_IDENTIFIANT", this.fiche == Fiches.ETABLISSEMENT);
          this.displayMap.set("STATUT_LICENCE_SPECTACLE", this.fiche == Fiches.ETABLISSEMENT && this.requiredMissing(requiredAttributs, "STATUT_LICENCE_SPECTACLE") || (this.editEtablissement.licenceStatus > 0 && !!this.fiche));
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
      readOnly (value: string): boolean {
        const sudo = storeSession.isSudo;

        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("POLE_EMPLOI_AFFILIATION", !sudo && this.fiche == Fiches.ETABLISSEMENT);
          this.readOnlyMap.set("POLE_EMPLOI_ADHESION", !sudo && this.fiche == Fiches.ETABLISSEMENT);
          this.readOnlyMap.set("POLE_EMPLOI_IDENTIFIANT", !sudo && this.fiche == Fiches.ETABLISSEMENT);
          this.readOnlyMap.set("STATUT_LICENCE_SPECTACLE", true);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      }, picto (): string {
        return 'SectionPictoImmatriculation'
      },
      sectionSave (): void {
        this.save();
        this.displayMap.clear();
      }
    }
  })

</script>
